import { Box, Typography, styled } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { imagesList } from "../../constants";

const CustomTurnoBenefitsPage = styled(Box)(() => ({
  margin: "10px",
}));

const TurnoBenefits = () => {
  return (
    <CustomTurnoBenefitsPage>
      <Box>
        <Box>
          <Typography
            style={{ margin: "10px", fontSize: "20px", fontWeight: "700" }}
          >
            Turno Benefits
          </Typography>
        </Box>
        <Box>
          <LazyLoadImage
            width={"100%"}
            src={imagesList.turnoBenefits}
            alt="Piaggio Ape-Xtra vs Diesel"
          />
        </Box>
      </Box>
    </CustomTurnoBenefitsPage>
  );
};

export default TurnoBenefits;
